import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Select, { MultiValue } from "react-select";
import { Link } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { contactData } from "../../../core/data/json/contactData";
import Table from "../../../core/common/dataTable/index";
import { Button, Form, Modal } from "react-bootstrap";
import { TableData } from "../../../core/data/interface";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
  setAddTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import { TagsInput } from "react-tag-input-component";
import { all_routes } from "../../router/all_routes";
import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { getContacts, addContact, updateContact, deleteContact, getContactDetail, getAccessibilityForContact, updateAccessibilityForContact, changeOwner } from "./contactAPI";
import { getAllCompanies, getAllCompaniesWithoutPaging } from "../companies/companyAPI";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  optionschoose,
  optionsource,
  optionssymbol,
  optionSalutation,
  ratingOptions
} from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import { Pagination } from "antd";
import ResponseModal from "../../../core/modals/response_modal";
import { Phone } from "react-feather";
import { getTagList } from "../tags/tagAPI";
import { userList } from "../leads/logcall_api";
import { userListByRole } from "../users/userAPI";
interface User {
  id: number;
  username: string;
  uuid: string;
  role: string;
}
interface AddContactForm {
  accountId: number;
  title: string;
  owner: string;
  email: string;
  phone: string;
  salutation: string;
  lastName: string;
  firstName: string;
  mobile: string;
  fax: string;
  reportTo: number | null;
  department: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  description: string;
  rating: number;
  status: string;
  facebook: string | null;
  skype: string | null;
  linkedin: string | null;
  twitter: string | null;
  instagram: string | null;
  whatsapp: string | null;
  is_public: boolean;
  memberId: number;
  selectedPeople: number[];
  tags: {
    tagId: number;
    name: string
  }[]
  ;
}
interface EditContactForm {
  accountId: number;
  title: string;
  owner: string;
  email: string;
  phone: string;
  salutation: string;
  lastName: string;
  firstName: string;
  mobile: string;
  fax: string;
  reportTo: number | null;
  department: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  description: string;
  rating: number;
  status: string;
  facebook: string | null;
  skype: string | null;
  linkedin: string | null;
  twitter: string | null;
  instagram: string | null;
  whatsapp: string | null;
  is_public: boolean;
  memberId: number;
  selectedPeople: number[];
  tags: {
    tagId: number;
    name: string
  }[]
  ;
}

interface Contact {
  contactId: number;
  contactName: string;
  title: string;
  phone: string | null;
  email: string | null;
  tagList: string[] | null;
  location: string | null;
  rating: number | null;
  ownerName: string | null;
  ownerUuid: string | null;
  facebook: string | null;
  twitter: string | null;
  linkedin: string | null;
  instagram: string | null;
  skype: string | null;
  whatsapp: string | null;
  status: string;
  accountId: number;
  accountName: string;
}

interface ContactDetail {
  contactId: number;
  accountId: number;
  accountName: string;
  salutation: string;
  title: string;
  contactOwnerUuid: string;
  contactOwnerName: string | null;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  mobileNumber: string;
  reportTo: number | null;
  reportToName: string | null;
  fax: string;
  department: string;
  mailingStreet: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  mailingCountry: string | null;
  description: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  rating: number | null;
  facebook: string | null,
  skype: string | null,
  linkedin: string | null,
  twitter: string | null,
  instagram: string | null,
  whatsapp: string | null,
  status: string;
  campaignHistory: {
    campaignId: number;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }[];
  opportunityContacts: {
    opportunityId: number;
    opportunityName: string;
    stage: string;
    amount: number;
    accountId: number;
    accountName: string;
    owner: string;
  }[];
  tagList: {
    tagId: number;
    name: string;
  }[];
}

interface ContactListRequest {
  property?: string | null;
  direction?: "ASC" | "DESC";
  contactName?: string | null;
  accountName?: string | null;
  email?: string | null;
  phone?: string | null;
  ownerName?: string[] | null;
}
interface TagOption {
  value: number;
  label: string;
}

interface UpdateContactDTO {
  accountId: number;
  title: string;
  owner: string;
  email: string;
  phone: string;
  salutation: string;
  lastName: string;
  firstName: string;
  mobile: string;
  fax: string;
  department: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  description: string;
  rating: number;
  status: string;
  facebook: string;
  skype: string;
  linkedin: string;
  twitter: string;
  instagram: string;
  whatsapp: string;
  isPublic: boolean;
  memberId: number;
  tags: Array<{ tagId: number; name: string }>;
}
const ContactList = () => {
  const route = all_routes;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [createdContactId, setCreatedContactId] = useState(null);
  const [editedContactId, setEditedContactId] = useState<number | null>(null);
  const [editingContact, setEditingContact] = useState<ContactDetail | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const [companies, setCompanies] = useState<{ label: string; value: number }[]>([]);
  useEffect(() => {
    getAllCompaniesWithoutPaging()
      .then(response => {
        console.log("Companies API response:", response.data);
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          const companyOptions = response.data.data.map((company: { accountName: string; accountId: number; accountUuid: string }) => ({
            label: company.accountName,
            value: company.accountId,
          }));
          setCompanies(companyOptions);
        } else {
          console.error("API response does not contain a valid list of companies:", response.data);
          setCompanies([]);
        }
      })
      .catch(error => {
        console.error("Error fetching companies:", error);
        setCompanies([]);
      });
  }, []);

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const initializeStarsState = () => {
    const starsState: { [key: number]: boolean } = {};
    contactData.forEach((item, index) => {
      starsState[index] = false;
    });
    setStars(starsState);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setNewContact(prevState => ({
      ...prevState,
      [name]: value
    }));
    setEditingContact((prevState) => {
      if (!prevState) return prevState;
      return {
        ...prevState,
        [name]: value,
        id: prevState.contactId ?? 0
      };
    });
  };

  const [errors, setErrors] = useState<Record<string, string>>({});
  const handleSelectChange = (
    selectedOption: SingleValue<{ label: string; value: string | number }>,
    field: string
  ) => {
    if (editingContact) {
      setEditingContact(prevState => ({
        ...prevState!,
        [field]: selectedOption ? selectedOption.value : "",
      }));
    } else {
      setNewContact(prevState => ({
        ...prevState,
        [field]: selectedOption ? selectedOption.value : "",
      }));
    }
  };

  const [newContact, setNewContact] = useState<AddContactForm>({
    accountId: 0,
    title: "",
    owner: "",
    email: "",
    phone: "",
    salutation: "",
    lastName: "",
    firstName: "",
    mobile: "",
    fax: "",
    reportTo: 0,
    department: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    description: "",
    rating: 0,
    status: "",
    facebook: "",
    skype: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    whatsapp: "",
    is_public: true,
    memberId: 0,
    selectedPeople: [] as number[],
    tags: [] as { tagId: number; name: string }[],
  });
    useEffect(() => {
      const userName = localStorage.getItem("userName") || "";
      setNewContact((prevState) => ({
        ...prevState,
        owner: userName,
      }));
    }, []);
  const [editContact, setEditContact] = useState<EditContactForm>({
    accountId: 0,
    title: "",
    owner: "",
    email: "",
    phone: "",
    salutation: "",
    lastName: "",
    firstName: "",
    mobile: "",
    fax: "",
    reportTo: 0,
    department: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    description: "",
    rating: 0,
    status: "",
    facebook: "",
    skype: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    whatsapp: "",
    is_public: true,
    memberId: 0,
    selectedPeople: [] as number[],
    tags: [] as { tagId: number; name: string }[],
  });
  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setEditingContact(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        tagList: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : []
      };
    });
  };
  const [data, setData] = useState<Contact[]>([]);
  const [filters, setFilters] = useState<ContactListRequest>({
    property: "contactId",
    direction: "ASC",
    contactName: null,
    accountName: null,
    email: null,
    phone: null,
    ownerName: [],
  });

  const [pagination, setPagination] = useState({
    totalPages: 1,
    totalElements: 0,
  });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSortChange = async (property: string, direction: "ASC" | "DESC") => {
    try {
      const newDirection = filters.direction === "ASC" ? "DESC" : "ASC";

      const updatedFilters = {
        ...filters,
        property,
        direction: newDirection as "ASC" | "DESC"
      };

      setFilters(updatedFilters);


      const response = await getContacts(updatedFilters);

      if (response.data && response.data.data) {
        setData(response.data.data.content || []);
        setPagination({
          totalPages: response.data.data.totalPages || 1,
          totalElements: response.data.data.totalElements || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching sorted contacts:", error);
    }
  };

  const applyFilters = async () => {
    try {
      setFilters((prevFilters) => {
        const updatedFilters = { ...prevFilters, pageNo: 0 };
        console.log("Reset pageNo before sending filters:", updatedFilters);
        return updatedFilters;
      });

      const response = await getContacts({ ...filters, pageNo: 0 });

      console.log("Response received:", response.data);
      setData(response.data.data.content || []);
      setPagination({
        ...pagination,
        totalElements: response.data.data.totalElements,
        totalPages: response.data.data.totalPages
      });
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      pageNo: newPage,
    }));
    fetchContacts(newPage);
  };
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  useEffect(() => {
    fetchTags();
  }, []);
  const fetchContacts = async (page: number = 0) => {
    try {
      const response = await getContacts({ ...filters, pageNo: page });
      console.log("API page:", page);
      console.log("API Response:", response.data.data);

      if (response.data && response.data.data && Array.isArray(response.data.data.content)) {
        setData(response.data.data.content);
        setPagination({
          totalPages: response.data.data.totalPages || 1,
          totalElements: response.data.data.totalElements || 0,
        });
      } else {
        console.error("API response does not contain a valid list:", response.data);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setData([]);
    }
  };
  const [users, setUsers] = useState<User[]>([]);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const fetchOwners = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userList(userTenantId);
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
      const owners = fetchedUsers.map((user: User) => ({
        value: user.uuid,
        label: user.username,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };
  const fetchUserByRole = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      const response = await userListByRole(userTenantId, "ACCOUNT_EXECUTIVE");
      const fetchedUsers = response.data.data;
      setUsers(fetchedUsers);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  useEffect(() => {
    fetchContacts();
    fetchUserByRole();
    fetchOwners();
  }, []);

  const userUuid = localStorage.getItem("userUuid");
  const memberId = localStorage.getItem("userId");
  const [errorsAddForm, setErrorsAddForm] = useState<Record<string, string>>({});

  const validateAddForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => /^0\d{9,10}$/.test(value);

    const isValidEmail = (email: string) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!newContact.firstName.trim()) newErrors.firstName = "First Name is required.";
    if (!newContact.lastName.trim()) newErrors.lastName = "Last Name is required.";
    if (!newContact.accountId) newErrors.account = "Company is required.";
    if (!newContact.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!isValidEmail(newContact.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!newContact.phone.trim()) {
      newErrors.phone = "Phone is required.";
    } else if (!isValidPhone(newContact.phone)) {
      newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";
    }

    if (newContact.mobile && !isValidPhone(newContact.mobile)) {
      newErrors.mobile = "Mobile must start with 0 and contain 10–11 digits only.";
    }

    // if (newContact.fax && !onlyDigits(newContact.fax)) {
    //   newErrors.fax = "Fax must contain digits only.";
    // }

    const fieldsMax50 = [
      "firstName", "lastName", "title", "owner", "email", "phone", "mobile", "fax",
      "department", "street", "city", "state", "country", "status",
      "facebook", "skype", "linkedin", "twitter", "instagram", "whatsapp"
    ];

    fieldsMax50.forEach((field) => {
      const value = (newContact as any)[field];
      if (value) isTooLong(value, field);
    });

    if (newContact.description && newContact.description.length > 256) {
      newErrors.description = "Description must not exceed 256 characters.";
    }

    if (newContact.zip) {
      if (!onlyDigits(newContact.zip) || newContact.zip.length !== 6) {
        newErrors.zip = "ZIP must be 6 digits and contain digits only.";
      }
    }

    setErrorsAddForm(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateContact = async () => {
    if (!validateAddForm()) {
      console.error("Validation failed:", validateAddForm);
      return;
    }
    try {
      const contactData = {
        accountId: newContact.accountId,
        title: newContact.title || "",
        owner: userUuid,
        email: newContact.email,
        phone: newContact.phone,
        salutation: newContact.salutation || "",
        firstName: newContact.firstName,
        lastName: newContact.lastName,
        mobile: newContact.mobile || "",
        fax: newContact.fax || "",
        reportTo: 0,
        department: newContact.department || "",
        street: newContact.street || "",
        city: newContact.city || "",
        state: newContact.state || "",
        zip: newContact.zip || "",
        country: newContact.country || "",
        description: newContact.description || "",
        rating: newContact.rating || "",
        status: newContact.status || "",
        facebook: newContact.facebook || "",
        skype: newContact.skype || "",
        linkedin: newContact.linkedin || "",
        twitter: newContact.twitter || "",
        instagram: newContact.instagram || "",
        whatsapp: newContact.whatsapp || "",
        is_public: newContact.is_public,
        memberId: memberId,
        selectedPeople: newContact.selectedPeople || [],
        tags: newContact.tags || []
      };
      try {
        const response = await addContact(contactData);
        console.log("API Response:", response.data);

        if (response.status === 200) {
          const createdId = response.data.data;
          setCreatedContactId(createdId);
          setOpenModal(true);
          fetchContacts(0);
          setNewContact({
            accountId: 0,
            title: "",
            owner: "",
            email: "",
            phone: "",
            salutation: "",
            firstName: "",
            lastName: "",
            mobile: "",
            fax: "",
            reportTo: 0,
            department: "",
            street: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            description: "",
            rating: 0,
            status: "",
            facebook: "",
            skype: "",
            linkedin: "",
            twitter: "",
            instagram: "",
            whatsapp: "",
            is_public: true,
            memberId: 0,
            selectedPeople: [],
            tags: []
          });
        }
      } catch (error: any) {
        console.error("Lá»—i khi gá»i API addContact:", error);
        const errorMessage = error.response?.data?.message || error.message;
        if (errorMessage.includes("Ids must not be null")) {
          console.log("Xá»­ lÃ½ trÆ°á»ng há»£p lá»—i 'Ids must not be null'");
          let contactId = null;
          if (error.response?.data?.data) {
            contactId = error.response.data.data;
            console.log("Láº¥y Ä‘Æ°á»£c ID tá»« dá»¯ liá»‡u lá»—i:", contactId);
          }
          if (contactId) {
            setCreatedContactId(contactId);
            setOpenModal(true);
            fetchContacts(0);
            setNewContact({
              accountId: 0,
              title: "",
              owner: "",
              email: "",
              phone: "",
              salutation: "",
              firstName: "",
              lastName: "",
              mobile: "",
              fax: "",
              reportTo: 0,
              department: "",
              street: "",
              city: "",
              state: "",
              zip: "",
              country: "",
              description: "",
              rating: 0,
              status: "",
              facebook: "",
              skype: "",
              linkedin: "",
              twitter: "",
              instagram: "",
              whatsapp: "",
              is_public: true,
              memberId: 0,
              selectedPeople: [],
              tags: []
            });
          } else {
            console.log("KhÃ´ng tÃ¬m tháº¥y ID trong pháº£n há»“i lá»—i, tÃ¬m kiáº¿m contact má»›i nháº¥t");
            alert("Contact Ä‘Ã£ Ä‘Æ°á»£c táº¡o nhÆ°ng khÃ´ng thá»ƒ xÃ¡c Ä‘á»‹nh ID. Vui lÃ²ng kiá»ƒm tra danh sÃ¡ch contacts.");
          }
        } else {
          alert("Lá»—i khi táº¡o contact: " + errorMessage);
        }
      }
    } catch (error: any) {
      console.error("Lá»—i ngoáº¡i lá»‡ khi táº¡o contact:", error);
      alert("Lá»—i khÃ´ng xÃ¡c Ä‘á»‹nh khi táº¡o contact: " + error.message);
    }
  };

  const [contacts, setContacts] = useState<{ label: string; value: number }[]>([]);

  useEffect(() => {
    getContacts()
      .then(response => {
        const contactOptions = response.data.data.content.map((contact: { contactId: number; contactName: string }) => ({
          label: contact.contactName,
          value: contact.contactId,
        }));
        setContacts(contactOptions);
      })
      .catch(error => console.error("Error fetching contacts:", error));
  }, []);

  const [showModalAccess, setShowModalAccess] = useState<boolean>(false);
  const [accessType, setAccessType] = useState<"public" | "private" | "isSelected">("public");
  const [selectedPeople, setSelectedPeople] = useState<any[]>([]);
  const [currentId, setCurrentId] = useState<number | null>(null);
  const [tempSelectedUsers, setTempSelectedUsers] = useState<any[]>([]);
  const handleCloseModalAccess = () => {
    setShowModalAccess(false);
    setCurrentId(null);
    setSelectedPeople([]);
    setAccessType("public");
  };

  const handleSetAccessibility = async (id: number) => {
    try {
      const response = await getAccessibilityForContact(id);
      const accessibilityData = response.data.data;

      setCurrentId(id);

      const isPublic = accessibilityData.public;
      const isPrivate = accessibilityData.private;
      const isSelected = accessibilityData.selected;
      const selected = accessibilityData.accessMembers || [];
      const selectedIds = selected.map((member: any) => member.memberId);

      if (isPublic && selectedIds.length === 0) {
        setAccessType("public");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isPrivate && selectedIds.length === 0) {
        setAccessType("private");
        setSelectedPeople([]);
        setTempSelectedUsers([]);
      } else if (isSelected) {
        setAccessType("isSelected");
        setSelectedPeople(selectedIds);
        setTempSelectedUsers(selectedIds);
      }

      setShowModalAccess(true);
    } catch (error) {
      console.error("Failed to fetch accessibility data:", error);
    }
  };
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccessType(e.target.value as "public" | "private" | "isSelected");
  };

  const handleSaveAccessibility = async () => {
    if (!currentId) return;

    let requestData;

    if (accessType === "public") {
      requestData = {
        public: true,
        selectedPeople: []
      };
    } else if (accessType === "private") {
      requestData = {
        public: false,
        selectedPeople: []
      };
    } else if (accessType === "isSelected") {
      requestData = {
        public: false,
        selectedPeople: tempSelectedUsers
      };
    }

    try {
      const response = await updateAccessibilityForContact(currentId, requestData);
      if (response.status === 200) {
        setShowModalAccess(false);
        setResponse({ status: "success", message: "Change accessibility successfully!" });
      } else {
        setResponse({ status: "error", message: "Failed to save accessibility" });
      }
    } catch (err) {
      console.error("Error saving accessibility:", err);
    } finally {
      setShowMessageModal(true);
    }
  };
  const [selectedRecordIds, setSelectedRecordIds] = useState<number[]>([]);
  const rowSelection = {
    selectedRowKeys: selectedRecordIds,
    onChange: (selectedKeys: any[]) => {
      setSelectedRecordIds(selectedKeys);
    },
  };
  const columns = [
    {
      title: "Contact Name",
      dataIndex: "contactName",
      key: "contactName",
      render: (text: string, record: Contact) => (
        <Link to={`/crm/contacts-details/${record.contactId}`} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: Contact, b: Contact) => a.contactName.localeCompare(b.contactName),
    },
    {
      title: "Company Name",
      dataIndex: "accountName",
      key: "accountName",
      sorter: (a: Contact, b: Contact) => a.accountName?.localeCompare(b.accountName || ""),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a: Contact, b: Contact) => a.title?.localeCompare(b.title || ""),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      sorter: (a: Contact, b: Contact) => (a.phone || "").localeCompare(b.phone || ""),
      render: (phone: string | null) => phone || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a: Contact, b: Contact) => (a.email || "").localeCompare(b.email || ""),
      render: (email: string | null) => email || "-",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_: unknown, record: Contact) => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{
              position: "absolute",
              inset: "0px auto auto 0px",
              margin: "0px",
              transform: "translate3d(-99.3333px, 35.3333px, 0px)",
            }}
            data-popper-placement="bottom-start"
          >
            {/* Edit Action */}
            <Link
              className="dropdown-item edit-popup"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#edit_Contact"
              onClick={() => record.contactId && handleEditClick(record.contactId)}
            >
              <i className="ti ti-edit text-blue"></i> Edit
            </Link>

            {/* Delete Action */}
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_contact"
              onClick={() => record.contactId && handleDeleteClick(record.contactId, record.contactName)}
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>
            {/* Set Accessibility Action */}
            <Link
              className="dropdown-item"
              to="#"
              onClick={() =>
                record.contactId &&
                handleSetAccessibility(record.contactId)
              }
            >
              <i className="ti ti-lock-open text-warning"></i> Set Accessibility
            </Link>
          </div>
        </div>
      ),
    }
  ];
  const [leadToDelete, setLeadToDelete] = useState<{ id: number; name: string } | null>(null);
  const handleDeleteClick = (id: number, name: string) => {
    setLeadToDelete({ id, name });
  };

  const handleEditClick = async (contactId: number) => {
    console.log("Lead UUID:", contactId);
    try {
      const response = await getContactDetail(contactId);
      console.log("APi response:", response.data.data.contactInformation);

      if (response.status === 200) {
        const contactData = response.data.data.contactInformation;
        const tagList = response.data.data.tagList || [];
        const campaignHistory = response.data.data.campaignHistory || [];
        const opportunityContacts = response.data.data.opportunityContacts || [];
        setEditingContact({
          ...contactData,
          tagList,
          campaignHistory,
          opportunityContacts
        });
        setEditedContactId(response.data.data.contactInformation.contactId);
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };

  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);
  const [errorsEditForm, setErrorsEditForm] = useState<Record<string, string>>({});

  const validateEditForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => /^0\d{9,10}$/.test(value);

    const isValidEmail = (email: string) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!editingContact?.firstName.trim()) newErrors.firstName = "First Name is required.";
    if (!editingContact?.lastName.trim()) newErrors.lastName = "Last Name is required.";
    if (!editingContact?.accountId) newErrors.account = "Company is required.";
    if (!editingContact?.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!isValidEmail(editingContact.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!editingContact?.phoneNumber.trim()) {
      newErrors.phone = "Phone is required.";
    } else if (!isValidPhone(editingContact.phoneNumber)) {
      newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";
    }

    if (editingContact?.mobileNumber && !isValidPhone(editingContact.mobileNumber)) {
      newErrors.mobile = "Mobile must start with 0 and contain 10–11 digits only.";
    }

    if (editingContact?.fax && !onlyDigits(editingContact.fax)) {
      newErrors.fax = "Fax must contain digits only.";
    }
    if (!editingContact?.contactOwnerUuid.trim()) newErrors.owner = "Owner is required.";
    const fieldsMax50 = [
      "firstName", "lastName", "title", "owner", "email", "phone", "mobile", "fax",
      "department", "street", "city", "state", "country", "status",
      "facebook", "skype", "linkedin", "twitter", "instagram", "whatsapp"
    ];

    fieldsMax50.forEach((field) => {
      const value = (editingContact as any)[field];
      if (value) isTooLong(value, field);
    });

    if (editingContact?.description && editingContact.description.length > 256) {
      newErrors.description = "Description must not exceed 256 characters.";
    }

    if (editingContact?.mailingZip) {
      if (!onlyDigits(editingContact.mailingZip) || editingContact.mailingZip.length !== 6) {
        newErrors.zip = "ZIP must be 6 digits and contain digits only.";
      }
    }

    setErrorsEditForm(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleUpdateContact = async () => {
    if (!editingContact?.contactId) {
      console.error("Error: No valid ID found for update!", editingContact);
      return;
    }
    if (!validateEditForm()) {
      console.error("Validation failed:", validateEditForm);
      return;
    }
    try {
      const updatedContact: UpdateContactDTO = {
        accountId: editingContact.accountId,
        title: editingContact.title || "",
        owner: editingContact.contactOwnerUuid,
        email: editingContact.email || "",
        phone: editingContact.phoneNumber || "",
        salutation: editingContact.salutation || "",
        lastName: editingContact.lastName,
        firstName: editingContact.firstName,
        mobile: editingContact.mobileNumber || "",
        fax: editingContact.fax || "",
        department: editingContact.department || "",
        street: editingContact.mailingStreet || "",
        city: editingContact.mailingCity || "",
        state: editingContact.mailingState || "",
        zip: editingContact.mailingZip || "",
        country: editingContact.mailingCountry || "",
        description: editingContact.description || "",
        rating: editingContact.rating || 0,
        facebook: editingContact.facebook || "",
        skype: editingContact.skype || "",
        linkedin: editingContact.linkedin || "",
        twitter: editingContact.twitter || "",
        instagram: editingContact.instagram || "",
        whatsapp: editingContact.whatsapp || "",
        status: editingContact.status || "",
        isPublic: editContact.is_public,
        memberId: editContact.memberId,
        tags: editingContact.tagList || []
      };
      console.log("Sending updated contact data:", updatedContact);
      const response = await updateContact(editingContact.contactId, updatedContact);

      if (response.status === 200) {
        console.log("Contact updated successfully");
        setEditedContactId(editingContact.contactId);
        setOpenEditSuccessModal(true);
        fetchContacts(0);
      }
    } catch (error: any) {

    } finally {
      setShowMessageModal(true);
    }
  };

  const handleConfirmDelete = async () => {
    if (!leadToDelete) return;
    try {
      const response = await deleteContact(leadToDelete.id);
      if (response.status === 200) {
        fetchContacts();
        setResponse({ status: "success", message: "Contact deleted successfully!" });
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
      setResponse({ status: "error", message: "Contact deleted failed!" });
    } finally {
      setShowMessageModal(true);
    }
  };

  // ThÃªm khÃ³a duy nháº¥t cho má»—i hÃ ng dá»¯ liá»‡u
  const contactsWithKeys = data.map((contact, index) => ({
    ...contact,
    key: contact.contactId || index,
  }));
  const [selectedOwnerUuid, setSelectedOwnerUuid] = useState<string>();
  const [showChangeOwnerModal, setShowChangeOwnerModal] = useState(false);
  const handleChangeOwner = async () => {
    try {
      if (selectedRecordIds.length === 0) {
        setResponse({ status: "error", message: "Please select at least one lead" });
        return;
      }
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setResponse({ status: "error", message: "User ID not found!" });
        return;
      }
      const response = await changeOwner(selectedRecordIds, selectedOwnerUuid);
      console.log("Change Owner:", response.data);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Change Owner successfully!" });
        setSelectedRecordIds([]);
        setSelectedOwnerUuid("");
        setShowChangeOwnerModal(false);
      }
    } catch (error) {
      console.error("Error change owner", error);
      setResponse({ status: "error", message: "Failed to change owner. Please try again." });
    } finally {
      setShowMessageModal(true);
    }
  };

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Contacts<span className="count-title">{contacts.length}</span>
                    </h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card ">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                          onClick={() => setEditingContact(null)}
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Contact
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>

                <div className="card-body">
                  {/* Search */}

                  {/* /Search */}
                  {/* Filter */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                    </div>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          className="btn btn-primary ms-2"
                          onClick={() => setShowChangeOwnerModal(true)}
                        >
                          <i className="ti ti-user" />
                          Change Owner
                        </Link>
                      </div>
                      {/* <div className="form-sorts dropdown me-2">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" />
                          Filter
                        </Link>
                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" />
                                Filter
                              </h4>
                            </div>
                            <div className="accordion" id="accordionExample">
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                  >
                                    Contact Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="collapseTwo"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="contactName"
                                      value={filters.contactName || ""}
                                      onChange={handleFilterChange}
                                      placeholder="Enter contact name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    data-bs-toggle="account"
                                    data-bs-target="#account"
                                  >
                                    Account Name
                                  </Link>
                                </div>
                                <div
                                  className="filter-set-contents accordion-collapse collapse show"
                                  id="account"
                                >
                                  <div className="filter-content-list">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="accountName"
                                      value={filters.accountName || ""}
                                      onChange={handleFilterChange}
                                      placeholder="Enter account name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-md-6">
                                    <button className="btn btn-light" onClick={() => setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      contactName: null,
                                      accountName: null,
                                    }))}>
                                      Reset
                                    </button>
                                  </div>
                                  <div className="col-md-6">
                                    <button className="btn btn-primary" onClick={applyFilters}>
                                      Apply Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  {/* /Filter */}
                  {/* Contact List */}
                  <div className="table-responsive custom-table">
                    <Table dataSource={contactsWithKeys} columns={columns} rowSelection={rowSelection} />
                  </div>
                  {/* /Contact List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Contact */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add New Contact</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Salutation</label>
                          <Select
                            className="select2"
                            options={optionSalutation}
                            classNamePrefix="react-select"
                            value={optionSalutation.find((option) => option.value === newContact.salutation) || null}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "salutation")
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={newContact.firstName}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.firstName && <small className="text-danger">{errorsAddForm.firstName}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={newContact.lastName}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.lastName && <small className="text-danger">{errorsAddForm.lastName}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Company Name <span className="text-danger">*</span>
                          </label>
                          <Select
                            className="select2"
                            options={companies}
                            placeholder="Choose Company"
                            classNamePrefix="react-select"
                            value={companies.find(option => option.value === newContact.accountId)}
                            onChange={(selectedOption) => setNewContact(prev => ({ ...prev, accountId: selectedOption?.value || 0 }))}
                            isSearchable={true}
                            isClearable={true}
                            filterOption={(option, inputValue) =>
                              option.label.toLowerCase().includes(inputValue.toLowerCase())
                            }
                          />
                          {errorsAddForm.account && <small className="text-danger">{errorsAddForm.account}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="email"
                            value={newContact.email}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.email && <small className="text-danger">{errorsAddForm.email}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="phone"
                            value={newContact.phone}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.phone && <small className="text-danger">{errorsAddForm.phone}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Mobile</label>
                          <input
                            type="text"
                            className="form-control"
                            name="mobile"
                            value={newContact.mobile}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.mobile && <small className="text-danger">{errorsAddForm.mobile}</small>}
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Fax</label>
                          <input
                            type="text"
                            className="form-control"
                            name="fax"
                            value={newContact.fax}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={newContact.title}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.title && <small className="text-danger">{errorsAddForm.title}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Ratings</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <Select
                              className="select2"
                              options={ratingOptions}
                              classNamePrefix="react-select"
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "rating")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Department</label>
                          <input
                            type="text"
                            className="form-control"
                            name="department"
                            value={newContact.department}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.department && <small className="text-danger">{errorsAddForm.department}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Owner</label>
                          <input
                            type="text"
                            className="form-control"
                            name="owner"
                            value={newContact.owner}
                            onChange={handleInputChange}
                            disabled
                            placeholder="Current user"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Tags
                          </label>
                          <Select
                            isMulti
                            options={allTags.map(tag => ({
                              value: tag.id,
                              label: tag.name
                            }))}
                            placeholder="Select tags"
                            classNamePrefix="react-select"
                            value={newContact.tags.map(tag => ({
                              value: tag.tagId,
                              label: tag.name
                            }))}
                            onChange={(selectedOptions) => {
                              setNewContact(prev => ({
                                ...prev,
                                tags: selectedOptions ? selectedOptions.map(option => ({
                                  tagId: option.value,
                                  name: option.label
                                })) : []
                              }));
                            }}
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                minHeight: "50px",
                                maxHeight: "auto",
                                overflowY: "auto",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />
                          {errors.tags && <small className="text-danger">{errors.tags}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0">
                          <label className="col-form-label">Description</label>
                          <textarea
                            className="form-control"
                            rows={5}
                            name="description"
                            value={newContact.description}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.description && <small className="text-danger">{errorsAddForm.description}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}

              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Street</label>
                          <input
                            type="text"
                            className="form-control"
                            name="street"
                            value={newContact.street}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.street && <small className="text-danger">{errorsAddForm.street}</small>}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="col-form-label">City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={newContact.city}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.city && <small className="text-danger">{errorsAddForm.city}</small>}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="col-form-label">State</label>
                          <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={newContact.state}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.state && <small className="text-danger">{errorsAddForm.state}</small>}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="col-form-label">Zip</label>
                          <input
                            type="text"
                            className="form-control"
                            name="zip"
                            value={newContact.zip}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.zip && <small className="text-danger">{errorsAddForm.zip}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Country</label>
                          <input
                            type="text"
                            className="form-control"
                            name="country"
                            value={newContact.country}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.country && <small className="text-danger">{errorsAddForm.country}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}

              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input
                            type="text"
                            className="form-control"
                            name="facebook"
                            value={newContact.facebook || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.facebook && <small className="text-danger">{errorsAddForm.facebook}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype</label>
                          <input
                            type="text"
                            className="form-control"
                            name="skype"
                            value={newContact.skype || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.skype && <small className="text-danger">{errorsAddForm.skype}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin</label>
                          <input
                            type="text"
                            className="form-control"
                            name="linkedin"
                            value={newContact.linkedin || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.linkedin && <small className="text-danger">{errorsAddForm.linkedin}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input
                            type="text"
                            className="form-control"
                            name="twitter"
                            value={newContact.twitter || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.twitter && <small className="text-danger">{errorsAddForm.twitter}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input
                            type="text"
                            className="form-control"
                            name="whatsapp"
                            value={newContact.whatsapp || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.whatsapp && <small className="text-danger">{errorsAddForm.whatsapp}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input
                            type="text"
                            className="form-control"
                            name="instagram"
                            value={newContact.instagram || ""}
                            onChange={handleInputChange}
                          />
                          {errorsAddForm.instagram && <small className="text-danger">{errorsAddForm.instagram}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCreateContact}
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add Contact */}
      {/* Edit Contact */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="edit_Contact"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Contact</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="accordion" id="main_accordion_2">
              {/* Basic Info */}
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#basic"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-user-plus fs-20" />
                    </span>
                    Basic Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse show"
                  id="basic"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Salutation</label>
                          <Select
                            className="select2"
                            options={optionSalutation}
                            classNamePrefix="react-select"
                            value={optionSalutation.find(
                              (option) => option.value === editingContact?.salutation
                            )}
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "salutation")
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            value={editingContact?.firstName}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.firstName && <small className="text-danger">{errorsEditForm.firstName}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="lastName"
                            value={editingContact?.lastName}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.lastName && <small className="text-danger">{errorsEditForm.lastName}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Company Name <span className="text-danger">*</span>
                          </label>
                          {companies.length > 0 && (
                            <Select
                              className="select2"
                              options={companies}
                              placeholder="Choose Company"
                              classNamePrefix="react-select"
                              value={companies.find(option => option.value === Number(editingContact?.accountId)) || null}
                              onChange={(selectedOption) => handleSelectChange(selectedOption, "accountId")}
                              isSearchable={true}
                              isClearable={true}
                              filterOption={(option, inputValue) =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                              }
                            />
                          )}
                          {errorsEditForm.account && <small className="text-danger">{errorsEditForm.account}</small>}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="email"
                            value={editingContact?.email}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.email && <small className="text-danger">{errorsEditForm.email}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="phoneNumber"
                            value={editingContact?.phoneNumber}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.phoneNumber && <small className="text-danger">{errorsEditForm.phoneNumber}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Mobile</label>
                          <input
                            type="text"
                            className="form-control"
                            name="mobileNumber"
                            value={editingContact?.mobileNumber}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.mobileNumber && <small className="text-danger">{errorsEditForm.mobileNumber}</small>}
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Fax</label>
                          <input
                            type="text"
                            className="form-control"
                            name="fax"
                            value={editingContact?.fax}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Tags</label>
                          <Select
                            isMulti
                            options={allTags.map(tag => ({
                              value: tag.id,
                              label: tag.name
                            }))}
                            value={editingContact?.tagList?.map(tag => ({
                              value: tag.tagId,
                              label: tag.name
                            })) || []}
                            onChange={handleTagChange}
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                minHeight: "50px",
                                maxHeight: "auto",
                                overflowY: "auto",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                          />

                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={editingContact?.title}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.title && <small className="text-danger">{errorsEditForm.title}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Ratings</label>
                          <div className="icon-form-end">
                            <span className="form-icon">
                              <i className="ti ti-star" />
                            </span>
                            <Select
                              className="select2"
                              options={ratingOptions}
                              classNamePrefix="react-select"
                              value={ratingOptions.find(
                                (option) => Number(option.value) === editingContact?.rating
                              )}
                              onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, "rating")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Department</label>
                          <input
                            type="text"
                            className="form-control"
                            name="department"
                            value={editingContact?.department}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.department && <small className="text-danger">{errorsEditForm.department}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Owner</label>
                          <input
                            type="text"
                            className="form-control"
                            name="owner"
                            value={editingContact?.contactOwnerName || ""}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-0">
                          <label className="col-form-label">Description</label>
                          <textarea
                            className="form-control"
                            rows={5}
                            name="description"
                            value={editingContact?.description || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.description && <small className="text-danger">{errorsEditForm.description}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Basic Info */}


              {/* Address Info */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#address"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-map-pin-cog fs-20" />
                    </span>
                    Address Info
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="address"
                  data-bs-parent="#main_accordion"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">Street Address</label>
                          <input
                            type="text"
                            className="form-control"
                            name="street"
                            value={editingContact?.mailingStreet || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.street && <small className="text-danger">{errorsEditForm.street}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={editingContact?.mailingCity || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.city && <small className="text-danger">{errorsEditForm.city}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">State</label>
                          <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={editingContact?.mailingState || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.state && <small className="text-danger">{errorsEditForm.state}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Country</label>
                          <input
                            type="text"
                            className="form-control"
                            name="country"
                            value={editingContact?.mailingCountry || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.country && <small className="text-danger">{errorsEditForm.country}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Zipcode</label>
                          <input
                            type="text"
                            className="form-control"
                            name="zip"
                            value={editingContact?.mailingZip || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.zip && <small className="text-danger">{errorsEditForm.zip}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Address Info */}

              {/* Social Profile */}
              <div className="accordion-item border-top rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#social"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-social fs-20" />
                    </span>
                    Social Profile
                  </Link>
                </div>
                <div
                  className="accordion-collapse collapse"
                  id="social"
                  data-bs-parent="#main_accordion_2"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Facebook</label>
                          <input
                            type="text"
                            className="form-control"
                            name="facebook"
                            value={editingContact?.facebook || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.facebook && <small className="text-danger">{errorsEditForm.facebook}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Skype</label>
                          <input
                            type="text"
                            className="form-control"
                            name="skype"
                            value={editingContact?.skype || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.skype && <small className="text-danger">{errorsEditForm.skype}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Linkedin</label>
                          <input
                            type="text"
                            className="form-control"
                            name="linkedin"
                            value={editingContact?.linkedin || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.linkedin && <small className="text-danger">{errorsEditForm.linkedin}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">Twitter</label>
                          <input
                            type="text"
                            className="form-control"
                            name="twitter"
                            value={editingContact?.twitter || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.twitter && <small className="text-danger">{errorsEditForm.twitter}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 mb-md-0">
                          <label className="col-form-label">Whatsapp</label>
                          <input
                            type="text"
                            className="form-control"
                            name="whatsapp"
                            value={editingContact?.whatsapp || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.whatsapp && <small className="text-danger">{errorsEditForm.whatsapp}</small>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-0">
                          <label className="col-form-label">Instagram</label>
                          <input
                            type="text"
                            className="form-control"
                            name="instagram"
                            value={editingContact?.instagram || ""}
                            onChange={handleInputChange}
                          />
                          {errorsEditForm.instagram && <small className="text-danger">{errorsEditForm.instagram}</small>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Social Profile */}
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdateContact}
              >
                Edit
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Contact */}
      {/* Delete Contact */}
      <div className="modal fade" id="delete_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Contacts?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> contact you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={handleConfirmDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Contact */}
      {/* Create Contact */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-header border-0 m-0 justify-content-end">
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => { setOpenModal(false); window.location.reload(); }}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-medal" />
            </div>
            <h3>Contact Created Successfully!!!</h3>
            <p>View the details of contact, created</p>
            <div className="col-lg-12 text-center modal-btn">
              <button
                onClick={() => {
                  setOpenModal(false);
                  window.location.reload();
                }}
                className="btn btn-outline-secondary"
              >
                Cancel
              </button>
              <Link
                to={`/crm/contacts-details/${createdContactId}`}
                onClick={() => setOpenModal(false)}
                className="btn btn-primary"
              >
                Ok
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Create Contact */}
      {/*Change Owner Modal */}
      {showChangeOwnerModal && (
        <div className="modal custom-modal fade show d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Owner</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowChangeOwnerModal(false)}
                  aria-label="Close"
                ><i className="ti ti-x" /></button>
              </div>

              <div className="modal-body">
                <Select
                  className="select2"
                  options={ownerOptions}
                  classNamePrefix="react-select"
                  value={ownerOptions.find((option) => option.value === selectedOwnerUuid) || null}
                  onChange={(selectedOption) => {
                    setSelectedOwnerUuid(selectedOption?.value);
                    window.location.reload();
                  }}
                  placeholder="Select Owner"
                />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => { window.location.reload(); setShowChangeOwnerModal(false) }}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleChangeOwner}>Change</button>
              </div>
              <ResponseModal
                show={showMessageModal}
                onClose={() => setShowMessageModal(false)}
                response={response}
              />
            </div>
          </div>
        </div>
      )}
      {/* Edit Contact Success Modal */}
      <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-chart-arcs" />
            </div>
            <h3>Contacts Edit Successfully!!!</h3>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to="/crm/contact-list"
                onClick={() => {
                  setOpenEditSuccessModal(false);
                }}
                className="btn btn-primary"
              >
                Ok
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
      {/* /Edit Contact Success Modal */}
      {/* Access Modal */}
      <Modal show={showModalAccess} onHide={handleCloseModalAccess} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Set Accessibility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Radio buttons */}
            <Form.Check
              type="radio"
              label="Public"
              value="public"
              name="access"
              checked={accessType === "public"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Private"
              value="private"
              name="access"
              checked={accessType === "private"}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Selected People"
              value="isSelected"
              name="access"
              checked={accessType === "isSelected"}
              onChange={() => {
                setAccessType("isSelected");
                setTempSelectedUsers(selectedPeople);
              }}
            />

            {accessType === "isSelected" && (
              <>
                <div className="mb-3 mt-3">
                  <label className="col-form-label">Select Users</label>
                  <Select
                    isMulti
                    name="users"
                    options={users.map(user => ({
                      value: user.id,
                      label: `${user.username} - ${user.role}`
                    }))}
                    value={users
                      .filter(user => tempSelectedUsers.includes(user.id))
                      .map(user => ({
                        value: user.id,
                        label: `${user.username} - ${user.role}`
                      }))}
                    onChange={(selectedOptions) => {
                      setTempSelectedUsers(selectedOptions.map(opt => opt.value));
                    }}
                    isSearchable={true}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        maxWidth: '100%',
                        overflow: 'hidden'
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        whiteSpace: 'nowrap'
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        maxWidth: '200px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      })
                    }}
                  />
                </div>

                {tempSelectedUsers.length > 0 && (
                  <div className="mt-2 p-2 border rounded bg-light">
                    <strong>Selected Users:</strong>
                    <ul className="mb-0 ps-3">
                      {tempSelectedUsers.map(userId => {
                        const user = users.find(u => u.id === userId);
                        return user ? (
                          <li key={user.id}>
                            {user.username} - {user.role}
                          </li>
                        ) : null;
                      })}
                    </ul>
                  </div>
                )}
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalAccess}>
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            setSelectedPeople(tempSelectedUsers);
            handleSaveAccessibility();
          }}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <ResponseModal
        show={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        response={response}
      />
    </div>
  );
};

export default ContactList;
